// @flow
/**
 * User: Mike Chung
 * Date: 4/3/2018
 * Time: 11:56 AM
 */
import React, {Fragment} from 'react';
import {FormGroup, Input, Pagination, PaginationItem, PaginationLink} from "reactstrap";
import * as _ from 'lodash';
import {Link, withRouter} from "react-router-dom";
import type {PageRange, PaginatorProps} from "./Paginator";
import type {History} from "../types/ReactRouterTypes";


function SelectablePaginator(props: PaginatorProps & { history: History }) {

    const totalPage = Math.ceil(props.totalCount / props.pageItem);

    const pageRange: PageRange = {
        from: Math.max(props.currentPage - 2, 1),
        to: Math.min(Math.max(props.currentPage - 2, 1) + 5, totalPage)
    };

    let range: Array<number> = _.range(pageRange.from, pageRange.to + 1);

    return (
        <Fragment>
            <Pagination>
                {props.currentPage > 1 &&
                <PaginationItem>
                    <PaginationLink onClick={() => {
                        if (typeof props.onClickPage === 'function') {
                            props.onClickPage(1);
                        }
                    }
                    } previous tag={Link} to={props.generateLink(1)}/>
                </PaginationItem>
                }

                {
                    _.map(range, (page: number) => {
                        return (

                            <PaginationItem key={page}>
                                <PaginationLink onClick={() => {
                                    if (typeof props.onClickPage === 'function') {
                                        props.onClickPage(page);
                                    }
                                }
                                } tag={Link} to={props.generateLink(page)}>
                                    {page}
                                </PaginationLink>
                            </PaginationItem>
                        )
                    })
                }

                {props.currentPage < totalPage &&
                <PaginationItem>
                    <PaginationLink onClick={() => {
                        if (typeof props.onClickPage === 'function') {
                            props.onClickPage(totalPage);
                        }
                    }
                    } next tag={Link} to={props.generateLink(totalPage)}/>
                </PaginationItem>
                }
            </Pagination>
            <FormGroup>
                <Input type="select" name="select" onChange={(e: SyntheticEvent<HTMLSelectElement>) => {
                    const page: number = +_.get(e, 'target.value');
                    if (typeof props.onClickPage === 'function' && !isNaN(page)) {
                        props.onClickPage(page);
                        props.history.push(props.generateLink(page));
                    }
                }} value={props.currentPage}>
                    {
                        _.times(totalPage, (i: number) => (
                            <option key={i}>{i + 1}</option>
                        ))
                    }
                </Input>
            </FormGroup>
        </Fragment>
    );
}

export default withRouter(SelectablePaginator);


// WEBPACK FOOTER //
// ./src/components/SelectablePaginator.js